const config = {
  publicUrl: process.env.PUBLIC_URL,
  version: process.env.REACT_APP_CURRENT_VERSION,
  dynamicsUrl: process.env.REACT_APP_DYNAMICS_URL,
  gcp: process.env.REACT_APP_GCP_API_KEY,
  stripe: process.env.REACT_APP_STRIPE_ID,
};

export default config;
